module.exports = __webpack_public_path__ + "static/img/advantage4.e2711cbb.png";